import { Cep } from '../shared/entity/Cep';
import api from './api';

const BASE_URL = '/cep';

class cepApi {
  async getCep(numeroCep: string) {
    try {
      let res = await api.get<Cep>(BASE_URL, { params: { numero: numeroCep } });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new cepApi();
